import React from 'react';
import './TeamMember.css'


class TeamMember extends React.Component {
	

	render(){
		var img = "";
		if(this.props.postFeaturedImage === undefined){
			img = "/assets/icons/person.png";
		} else {
			img = this.props.postFeaturedImage;
		}
		
		return(
			<div className="TeamMemeberwrapper">
				<div className="TeamMemeberWrapperImg">
					<img alt="team tushek member" className="TeamMemeberImg" src={img} />
				</div>
				<div className="TeamMemeberName">{this.props.name2.toUpperCase()}</div>
				<div className="TeamMemeberTitle">{this.props.title.toUpperCase()}</div>
				<a className="TeamMemeberLinkLNWrapper" href={this.props.linkLN}><img className="TeamMemeberLinkLN" alt="" src="assets/icons/linkedin.png" /></a>
			</div>
		);
	}
}



export default TeamMember;


// WEBPACK FOOTER //
// ./src/components/TeamMember.js